import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import LocalStorageKeys from '../../cache/LocalStorageKeys'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import AccountListUI from './AccountListUI.js'

class AccountListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: [],
      successMsg: null,
      connectingAccountId: null,
      disconnectingAccountId: null,
      switchingAccountId: null
    }
  }

  render() {
    return (
      <AccountListUI
        context={this.props.context}
        accountList={this.props.accountList}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        onSwitchClick={this.onSwitchClick}
        onConnectClick={this.onConnectClick}
        onDisconnectClick={this.onDisconnectClick}
        onRefreshClick={this.props.onRefreshClick}
        connectingAccountId={this.state.connectingAccountId}
        disconnectingAccountId={this.state.disconnectingAccountId}
        switchingAccountId={this.state.switchingAccountId}
      />
    )
  }

  onSwitchClick = (event) => {
    let accountId = event.currentTarget.getAttribute('data-account-id')
    this.setState({switchingAccountId: accountId})

    // set this account as primary
    RestApiUtils.put(this.props.context,
      '/api/switchAccount', this.onSwitchClickCallback, {
        accountId: accountId
      }
    )
  }

  onSwitchClickCallback = (response) => {
    console.log(this.className, 'onSwitchClickCallback');
    this.setState({switchingAccountId: null})

    let context = this.props.context
    context.account = response.account
    context.session.accountId = response.account.accountId
    context.permissions = response.permissionList
    localStorage.setItem(LocalStorageKeys.Session, JSON.stringify(context.session))
    localStorage.setItem(LocalStorageKeys.Session + ':CachedTime', Date.now()/1000)
    sessionStorage.setItem(CacheKeys.Account(response.account.accountId), JSON.stringify(response.account))
    sessionStorage.setItem(CacheKeys.Account(response.account.accountId) + ':CachedTime', Date.now()/1000)
    localStorage.setItem(CacheKeys.Account(response.account.accountId), JSON.stringify(response.account))
    sessionStorage.setItem(CacheKeys.Permissions(response.account.accountId, response.session.userId), JSON.stringify(response.permissionList))
    sessionStorage.setItem(CacheKeys.Permissions(response.account.accountId, response.session.userId) + ':CachedTime', Date.now()/1000)
    localStorage.setItem(CacheKeys.Permissions(response.account.accountId, response.session.userId), JSON.stringify(response.permissionList))
    context.onContextChange(context)
  }

  onConnectClick = (event) => {
    event.preventDefault()
    let connectingAccountId = this.state.connectingAccountId
    if (connectingAccountId)
      return

    let accountId = event.currentTarget.getAttribute('data-account-id')
    this.setState({connectingAccountId: accountId})
    RestApiUtils.put(this.props.context,
      `/api/user/accounts/${accountId}`,
      this.onConnectSubmitCallback, {}
    )
  }

  onConnectSubmitCallback = (response) => {
    if (response.errorList.length > 0) {
      this.setState({connectingAccountId: null, errorList: response.errorList})
      return
    }
    this.setState({connectingAccountId: null, successMsg: response.successMsg})
    this.props.onConnectionUpdate(response.connectedAccount);
  }

  onDisconnectClick = (event) => {
    event.preventDefault()
    let disconnectingAccountId = this.state.disconnectingAccountId
    if (disconnectingAccountId)
      return

    let accountId = event.currentTarget.getAttribute('data-account-id')
    this.setState({disconnectingAccountId: accountId})
    RestApiUtils.delete(this.props.context,
      `/api/user/accounts/${accountId}`,
      this.onDisconnectSubmitCallback
    )
  }

  onDisconnectSubmitCallback = (response) => {
    if (response.errorList.length > 0) {
      this.setState({disconnectingAccountId: null, errorList: response.errorList})
      return
    }
    this.setState({disconnectingAccountId: null, successMsg: response.successMsg})
    this.props.onConnectionUpdate(response.connectedAccount);
  }

}

export default AccountListSF
